import axios from "axios";
import { takeLatest, call, put, select } from "redux-saga/effects";
import { createAction } from "redux-actions";
import { queryParams } from "../../../../../../utils/queryParams.js";

export const FETCH_CURRENT_USER = "saga/FETCH_CURRENT_USER";
export const FETCH_CURRENT_USER_SUCCESS = "saga/FETCH_CURRENT_USER_SUCCESS";
export const FETCH_CURRENT_USER_FAILURE = "saga/FETCH_CURRENT_USER_FAILURE";
export const SEARCH_CLIENTS = "saga/SEARCH_CLIENTS";
export const SEARCH_CLIENTS_SUCCESS = "saga/SEARCH_CLIENTS_SUCCESS";
export const SEARCH_CLIENTS_FAILURE = "saga/SEARCH_CLIENTS_FAILURE";
export const SHOW_TABLE = "saga/SHOW_TABLE";
export const TABLE_LOADING = "saga/TABLE_LOADING";

export const actionCreators = {
  fetchCurrentUser: createAction(FETCH_CURRENT_USER),
  searchClients: createAction(SEARCH_CLIENTS)
};

export default function* watchStars() {
  yield takeLatest(FETCH_CURRENT_USER, getCurrentUserData);
  yield takeLatest(SEARCH_CLIENTS, getClients);
}

export function* getCurrentUserData(data) {
  yield put({ type: FETCH_CURRENT_USER_SUCCESS, payload: data.payload });
}

export function* getClients(payload) {
  yield put({ type: SHOW_TABLE, payload: true });
  yield put({ type: TABLE_LOADING, payload: true });
  const id = yield select(state => state.clientProfileSearch.currentUser.organization_id);
  const objectId = yield select(state => state.clientProfileSearch.currentUser.current_object_id);
  const locationId = yield select(state => state.clientProfileSearch.currentUser.current_location_id);
  const regionId = yield select(state => state.clientProfileSearch.currentUser.current_region_id);
  try {
    const response = yield call(
      axios.get,
      queryParams.apiVersion +
        "clients" +
        "?organization_id=" +
        id +
        "&location_id=" +
        locationId +
        "&region_id=" +
        regionId +
        "&object_id=" +
        objectId +
        "&limit=" +
        15 +
        "&search=" +
        payload.payload
    );
    yield put({ type: SEARCH_CLIENTS_SUCCESS, payload: response });
  } catch (error) {
    console.error(error);
    yield put({ type: SEARCH_CLIENTS_FAILURE, error });
  }
}
